import React from 'react';


export default function Level(props) {

  return (
    <div className="border">
    <h1 className="score">Level</h1>
    <h1 className="score">1</h1>
    </div>
  )
}
